// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"e943be58","484":"e8cf9161","787":"140aa59f"}[chunkId] + ".chunk.js";
};